<footer>
    <div class="footer-container">
        <div class="footer">
            <div class="footer-div">
                <div class="footer-tittle">Overlast melden?</div>
                <div class="footer-sub-title">U kunt 24/7 een milieuklacht indienen.</div>
                <div class="footer-button-wrap">
                    <a class="w-button" href="{{ environment.webform_url }}" title="Meldformulier milieuklachten">
                        Meldformulier
                        <mat-icon>arrow_circle_right</mat-icon>
                    </a>
                    <div class="text-line-block max-width">
                        Of bel <a class="link" href="tel:+31736812821" title="Telefoonnummer MilieuklachtenCentrale Brabant">073681 28 21</a> (Brabant)
                        of <a class="link" href="tel:+310118412323" title="Telefoonnummer MilieuklachtenCentrale Zeeland">0118 41 2323</a> (Zeeland)
                    </div>
                </div>
            </div>
        </div>
        <div class="last-div">
            <div class="last-text">
                © 2016-{{ year }} Milieu Klachtencentrale
                <a class="footer-link" href="{{ environment.homepage_url }}/disclaimer" title="Bekijk de pagina disclaimer op omwb.nl">Disclaimer</a>
                <a class="footer-link" href="{{ environment.homepage_url }}/privacyverklaring" title="Bekijk de pagina privacy">Privacyverklaring</a>
            </div>
        </div>
    </div>
</footer>
